export function pageview(path) {
  window.gtag && window.gtag('event', 'page_view', { page_path: path });
}
